import { Box, Typography } from '@mui/material'
import { CustomContentProps, SnackbarContent } from 'notistack'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import SnackbarCloseButton from './SnackbarCloseButton'

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.effectStyles.shadowStrong,
  },
  variantSuccess: {
    backgroundColor: theme.shape.snackbar.backgroundColor.successLight,
    color: theme.shape.snackbar.color.successDark,
  },
  variantError: {
    backgroundColor: theme.shape.snackbar.backgroundColor.errorLight,
    color: theme.shape.snackbar.color.errorDark,
  },
  variantWarning: {
    backgroundColor: theme.shape.snackbar.backgroundColor.warningLight,
    color: theme.shape.snackbar.color.warningDark,
  },
  variantInfo: {
    backgroundColor: theme.shape.snackbar.backgroundColor.informationLight,
    color: theme.shape.snackbar.color.informationDark,
  },
}))

/**
 * Custom Snackbar component for better styling
 */
const Snackbar = React.forwardRef<HTMLDivElement, CustomContentProps>(({ id, ...props }, ref) => {
  const { classes, cx } = useStyles()
  const hasIcon = props.iconVariant?.[props.variant]

  return (
    <SnackbarContent
      ref={ref}
      className={cx(classes.root, {
        [classes.variantSuccess]: props.variant === 'success',
        [classes.variantError]: props.variant === 'error',
        [classes.variantInfo]: props.variant === 'info',
        [classes.variantWarning]: props.variant === 'warning',
      })}
    >
      {hasIcon && <Box sx={{ mr: 2 }}>{props.iconVariant[props.variant]}</Box>}
      <Typography variant="body2">{props.message}</Typography>
      <SnackbarCloseButton snackbarKey={id} />
    </SnackbarContent>
  )
})

Snackbar.displayName = 'Snackbar'

export default Snackbar
